module.exports = __webpack_public_path__ + "img/diamond.f66d9e6.png";